// If set, will guarantee no questions of this type ever chosen (works for diagram or codebook splits)
export const GUARANTEED_NONE = "GUARANTEED_NONE";

// If set, will guarantee only questions of this type will be chosen (works for diagram or codebook splits)
export const GUARANTEED_ALWAYS = "GUARANTEED_ALWAYS";

export const APP_TO_BUILD = import.meta.env.VITE_APP_TO_BUILD;
